import type {
  ContestState,
  Game,
  GameMission,
  GameStateResponse,
  Lang,
  MissionSummary,
  PairingAttemptResponse,
  PairingStateResponse,
} from "@shared";
import { apiDelete, apiFetch, apiPost } from "../api/client";

/** Appels du jeu, côté jeune. Toutes ces routes exigent d'être connecté. */

export const fetchState = () => apiFetch<GameStateResponse>("/game/state");

export const startMission = (game: Game = "objects") =>
  apiPost<GameMission>("/game/mission/start", { game });

// --- Mission 2 --------------------------------------------------------------

export const fetchPairing = () => apiFetch<PairingStateResponse>("/game/pairing");

export const attemptPairing = (characterId: string, planetId: string) =>
  apiPost<PairingAttemptResponse>("/game/pairing/attempt", { characterId, planetId });

export const finishMission = () => apiPost<MissionSummary>("/game/mission/finish");

export const addFind = (appObjectId: string) =>
  apiPost<{ ok: true }>("/game/finds", { appObjectId });

export const removeFind = (appObjectId: string) => apiDelete(`/game/finds/${appObjectId}`);

/** Bouton « Mission acceptée » au bas du mot de bienvenue. */
export const acceptWelcome = () => apiPost<{ welcomeSeen: boolean }>("/game/welcome/accept");

// --- Concours de fin ---------------------------------------------------------

/**
 * Participation au tirage au sort.
 *
 * `lang` accompagne l'envoi pour que le serveur enregistre QUELLE version du
 * texte de consentement a été acceptée — le français et l'anglais n'ont pas la
 * même empreinte.
 */
export const enterContest = (email: string, consent: boolean, lang: Lang) =>
  apiPost<ContestState>("/game/contest/entry", { email, consent, lang });

/** La page de consentement, rendue par le serveur depuis content/consent.*.md. */
export interface ConsentPageResponse {
  lang: Lang;
  html: string;
  version: string;
  updatedAt: string;
}

export const fetchConsent = (lang: Lang) => apiFetch<ConsentPageResponse>(`/consent/${lang}`);

/** mm:ss — le format le plus lisible pour une mission de quelques dizaines de minutes. */
export function formatDuration(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
